export default __webpack_public_path__ + "static/waffle2-f2e276ce9f323c454f6411e4fcd10065.svg";